// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pageNotFound_title__37Jmi {\n  padding-top: 120px;\n  text-align: center;\n}", ""]);
// Exports
exports.locals = {
	"title": "pageNotFound_title__37Jmi"
};
module.exports = exports;
